import React from "react";
import { Table } from "antd";
import { IconDelete, IconEdit } from "../../../../common/ui/icons";
import TablePageSize from "./TablePageSize";

const NightPlacementTable = ({
  data,
  onChange,
  loading,
  changePageSize,
  editPlacement,
  deletePlacementFromList
}) => {
  const columns = [
    {
      title: "Наименование",
      dataIndex: "place",
      key: "place"
    },
    {
      title: "Адрес м. размещения",
      dataIndex: "address",
      key: "address"
    },
    {
      title: "Размещающая организация",
      dataIndex: "organization",
      key: "organization"
    },
    {
      dataIndex: "kids_night_list_id",
      render: kids_night_list_id => {
        return (
          <div style={{ minWidth: "64px", textAlign: "right" }}>
            <IconEdit
              style={{ color: "#00A8FF", marginRight: 16 }}
              onClick={() => {
                editPlacement(kids_night_list_id);
              }}
            />
            <IconDelete
              style={{ color: "#F5222D" }}
              onClick={() => {
                deletePlacementFromList(kids_night_list_id);
              }}
            />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data.data}
        className={"placement-table"}
        rowKey={"kids_night_list_id"}
        onChange={onChange}
        loading={loading}
        locale={{
          emptyText: loading
            ? " "
            : "Места размещения детей в ночное время не добавлены"
        }}
        pagination={{
          pageSize: data ? data.per_page : 0,
          total: data ? data.total : 0,
          current: data ? data.current_page : 0
        }}
      />
      {data && data.data && data.data.length > 0 && (
        <TablePageSize
          changePageSize={changePageSize}
          pages={data ? data.per_page : 0}
        />
      )}
    </>
  );
};

export default NightPlacementTable;
